import * as tConst from "../../../common/Constants";
import moment from "moment";

export function findPrevQuarterStart(date){
    const _startOfCalendarQuarter = moment(date).startOf("quarter")
    // trekk fra en dag
    const _dayBefore_startOfCalendarQuarter = new Date (_startOfCalendarQuarter.toDate() -1)
    // Finn begynnelsen på kvartalet igjen
    const _startOfPrevCalQuarter = moment(_dayBefore_startOfCalendarQuarter).startOf("quarter")

    const _startOfPrevQuarter = getTimelineQuarter(_startOfPrevCalQuarter.toDate())

    return _startOfPrevQuarter

}

export function findNextQuarterStart(date){
    const _endOfCalendarQuarter = moment(date).endOf("quarter")
    const _nextQuarterStart = getTimelineQuarter(_endOfCalendarQuarter);
    return _nextQuarterStart

}

function getTimelineQuarter(calenderQuarterStartDate) {
    const _start = new Date(2020, 0, 9, tConst.START_TIME);

    const _diff = (calenderQuarterStartDate - new Date(2020, 0, 9, 0, 0, 0, 0)) / (1000 * 60 * 60 * 24);
    const _remainingDays = 14 - (_diff % 14);

    _start.setDate(_start.getDate() + (_diff + _remainingDays));

    return _start;

}

export default getTimelineQuarter;